import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useClubContentHttp } from '@/core/api/club-contents'
import { ClubContent, ClubContentPayload } from '@/core/models/club-content'

export type ClubContentCollection = {
    data: Array<ClubContent>,
    meta?: MetaPayload,
    links?: any
}

const state: ClubContentCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const clubContentCollection: Module<ClubContentCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ClubContentCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ClubContentPayload) => {
                state.data.push(new ClubContent(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useClubContentHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ClubContentCollection): ClubContentCollection => {
            return state
        }
    }
}
